const styles = theme => ({
  sponsor: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    filter: 'grayscale(1)',
    transition: theme.transitions.create(['filter'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.standard
    }),
    '&:active, &:hover': {
      filter: 'grayscale(0)'
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Sponsors/Sponsor/styles.js